import React, { useEffect, useState } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { isCartAddToast } from "../utils/cartToast";
import "./MobileCartShortcut.css";

function MobileCartShortcut({ itemCount = 0 }) {
  const location = useLocation();
  const [activeCartToastIds, setActiveCartToastIds] = useState(() => new Set());

  useEffect(() => {
    const unsubscribe = toast.onChange((toastItem) => {
      if (!isCartAddToast(toastItem)) {
        return;
      }

      setActiveCartToastIds((current) => {
        const next = new Set(current);

        if (toastItem.status === "removed") {
          next.delete(toastItem.id);
        } else {
          next.add(toastItem.id);
        }

        if (next.size === current.size && [...next].every((id) => current.has(id))) {
          return current;
        }

        return next;
      });
    });

    return unsubscribe;
  }, []);

  const normalizedCount = Math.max(0, Number(itemCount) || 0);
  const shouldRender =
    location.pathname === "/cardapio" &&
    normalizedCount > 0 &&
    activeCartToastIds.size === 0;

  if (!shouldRender) {
    return null;
  }

  return (
    <Link
      to="/carrinho"
      className="mobile-cart-shortcut"
      aria-label={`Ir para o carrinho. ${normalizedCount} ${
        normalizedCount === 1 ? "item" : "itens"
      } no carrinho.`}
    >
      <FaShoppingCart aria-hidden="true" />
    </Link>
  );
}

export default MobileCartShortcut;
